var _rect, _path, _path2, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPin(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.596,
    y: 0.632,
    width: 12,
    height: 6,
    rx: 1,
    transform: "rotate(45 14.596 .632)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.89 4.167l5.656 5.657-6.364 6.364-5.657-5.657z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.096 9.738a1 1 0 011.208.158l5.513 5.513a1 1 0 01.159 1.208l-1.556 2.687a1 1 0 01-1.572.206l-6.645-6.644a1 1 0 01.206-1.573l2.687-1.555z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.768,
    y: 10.531,
    width: 2,
    height: 16,
    rx: 1,
    transform: "rotate(45 11.768 10.531)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default ForwardRef;